export default {
  autoLocale: {
    switchTitle: '语言切换提示',
    switchMessage: '根据您所在地区，{target} 可能更适合当前浏览。是否进行切换？',
    switchConfirm: '切换为{target}',
    switchCancel: '保持当前'
  },
  Mac_desktop_version:'macOS 桌面版',
  System_requirements_Applicable_to_Mac_OS:'下载说明：适用于 MacOS 操作系统安装',
  Forex_Leverage: '外汇杠杆',
  handerImgRightTips: [
    '面部清晰展示',
    '身份证信息完整呈现',
    '光线适宜',
    '背景纯色',
  ],
  field_cannot_be_empty_or_space: '字段不能为空或纯空格',
  please_select_gender: '请选择性别',
  please_select_nationality: '请选择国籍',
  please_select_birthday: '请选择出生日期',
  handerImgWrongTips: [
    '照片模糊，未对焦',
    '未清晰显示细节',
    '面部遮挡问题',
    '身份证遮挡情况',
  ],
  customersNum: '客户数',
  Funds: '资金',
  Make_sure_the_photo_holding_your_ID_shows_your_face_your_ID_card_is_not_blocked_and_the_text_on_your_ID_card_is_clear: '确保手持证件照文件显示您的面部、身份证无遮挡、身份证文字信息清晰',
  No_handling_fee_is_charged_funds_are_withdrawn_to_your_own_MT4_account: '不收取手续费，资金提取到本人的MT4账户',
  Unlimited_amount: '不限额度',
  Transfer_to_MT4_account: '内转到MT4账户',
  Agent_Backstage: '代理后台',
  Convert_to_IB: '转换为IB',
  Bank_Name: '银行名称',
  Annex_1: '附件1',
  Annex_2: '附件1',
  Return_to_old_version: '返回旧版',
  If_the_old_phone_cannot_be_used_please_contact_customer_service_to_request_modification: '*如当前手机号无法使用,请联系客服申诉修改',
  Current_mobile_phone_number: '当前手机号',
  Bonus_Account: '赠金账户',
  Redemption_Details: '兑换详情',
  Contact_Number: '联系电话',
  Consignees_name: '收货人姓名',
  Apply_for_redemption: '申请兑换',
  Order_Information: '订单信息',
  Please_fill_in_the_delivery_address: '请填写收货地址',
  Delivery_address: '收货地址',
  Confirm_your_order: '确认订单',
  Go_to_checkout: '去结算',
  Deduction_of_points: '扣除积分',
  My_Points: '我的积分',
  integral: '积分',
  Select_All: '全选',
  Cart: '购物车',
  add_to_the_cart: '加入购物车',
  Sales: '销量',
  Sticky: '置顶',
  Start_Activation: '开始激活',
  Convenience_store_code_payment: '超商代码支付',
  Card_punch: '卡打卡网银',
  Channel_Type: '通道类型',
  payment_bank:"支付银行",
  direct_bank_connection:'银行直连',
  scan_the_code_for_online_banking:'网银扫码',
  Bank_Code: '银行代码',
  Player_Account: '付款账户',
  Supermarket_Code: '超商代码',
  Account_Source: '账户来源',
  homePage: {
    currency: '币种'
  },
  Usernames_are_not_allowed_to_contain_special_characters: '用户名不允许含有特殊字符',
  Cent_accounts_allow_two_decimal_places_other_accounts_allow_one_decimal_place: 'Cent账户允许四位小数,其他账户允许一位小数',
  Cent_account_Stock_type_allows_two_decimal_places: 'Cent账户Stock类型允许两位小数',
  Cent_account_Crypto_type_allows_two_decimal_places: 'Cent账户Crypto类型允许两位小数',

  mt4DetailSetting: {
    leverTips: [
      '1、净值<1000，外汇杠杆最高1000',
      '2、净值<50000，外汇杠杆最高500',
      '3、净值<100000，外汇杠杆最高400',
      '4、净值<200000，外汇杠杆最高200',
      '5、净值>=200000，外汇杠杆最高100',
    ],
  },
  faq: {
    Account_related: '账户相关',
    Agency_related: '代理相关',
    Transaction_related: '交易相关',
    Deposits_and_withdrawals: '存取款',
  },
  navBar:{
    Switch_to_customer: '切换为客户',
    Switch_to_IB: '切换为代理',
  },
  menu: {
    Commission_details: '佣金明细',
  },
  customerHome:{
    Account_type_settings: '账户类型设置',
    MAM_master: 'MAM主',
    MAM_invest: 'MAM投资',

  },
  copyMaster:{
    No_trading_cycle_yet: '暂无交易周期',
    public: '公开',
    private: '不公开',
    Have_a_subscription_password: '有订阅密码',
    No_subscription_password: '无订阅密码',
    No_subscription_yet: '暂无订阅',
    Number_of_managed_accounts: '管理账户数',
    copy_pay: '订阅支出',
    Please_subscribe_to_the_trader_first_and_then_view_the_details: '请先订阅交易员,再查看详情',
    view_the_details: '查看详情',
    strategy: '策略',
    Not_active: '未生效',
    Subscribe_to_Trader: '订阅交易员',
    key_words: '关键词',
    Subscription_time: '订阅时间',
    Subscription_status: '订阅状态',
    pause: '暂停',
    No_active_subscription_yet: '暂无有效订阅',
    Go_subscribe_now: '现在去订阅',
    investment: '投资',
    MAM_status: 'MAM状态',
    month: '个月',
  },
  bonusList: {
    Deposit_Activity_Account: '入金/活动账户',
    Deposit_account: '入金账户',
    Activity_Account: '活动账户',
    Deposit_Time: '入金时间',
    Cancel_bonus: '取消赠金',
    Apply_for_regularization: '申请转正',
    Cancel_credit: '取消信用额',
    Passed_the_regularization: '转正通过',
    Rejection_of_regularization: '转正拒绝',

  },
  USD_account: '美元账户',
  Cent_Account: '美分账户',
  Bonus_management: '赠金管理',
  home: '首页',
  My_profile: '我的档案',
  funds_management: '资金管理',
  Download_Center: '下载中心',
  trading_software: '交易软件',

  commission: '手续费',
  Only_jpg_png_images_can_be_uploaded_and_should_not_exceed_10MB: '只能上传jpg/png图片，且不超过10MB',
  integral_Shop: '积分商城',
  product_detail: '商品详情',
  security_settings: '安全设置',
  Withdraw: '取出资金',
  funds_list: '资金流水',
  audit_list: '审核记录',
  trader_Report: '交易报告',
  announcement: '公告消息',
  transaction_documents: '交易文件',
  Files: '文件资料',
  Agent_area: '代理专区',
  My_promotion: '我的推广',
  My_customer: '我的客户',
  Symbol_Statistics: '品种统计',
  Commission_Statistics: '返佣统计',
  Performance_Statistics: '业绩统计',
  Opening_lot: '开仓手数',
  Submission_for_review_successful: '提交审核成功',
  withdraw365: 'ChipPay(原OTC365)',
  Audit_Reject: '审核拒绝',
  Please_select_the_payment_account: '请选择收款账户',
  // 新加的end
  The_format_of_uploaded_pictures_is_only_jpg_jpeg_png_bmp_tiff: '上传图片的格式仅限jpg/jpeg/png/bmp/tiff',

  // 新加的
  Price: '价格',
  Way: '方式',
  Activation_successful: '激活成功',
  Please_enter_the_activation_code: '请输入激活码',
  Active_account: '激活码激活',
  Charged_when_the_trading_cycle_is_enabled_Performance_fees_are_as_shown_below_and_are_charged_at_settlement: '启用交易周期时收取。表现费如下表，结算时收取。',
  my_subscription: '我的订阅',
  and_activate: '并激活',
  Please_check_your_email: '请查看您的邮箱',
  Email_sent: '已发送邮件',
  recertification: '重新认证',
  Data_review_failed: '资料审核失败',
  The_estimated_review_time_is_1_3_working_days_please_be_patient: '预计审核时间1-3个工作日,请耐心等待',
  To_verify_your_identity_information_please_prepare_your_ID_card_passport_and_ID_photo: '需核实身份信息,请准备好身份证 (护照) 证件照',
  Activation_email_sent: '已发送激活邮件',
  Demo_account_opened_successfully: '模拟账户开户成功',
  Account_ratings_in_the_past_13_weeks: '近13周账号评级',
  sign_out: '退出登录',
  View_rebate_rules: '查看返佣规则',
  Please_enter_the_sub_IB_level_name: '请输入子IB级别名称',
  Add_sub_IB_link: '添加子IB链接',
  Sub_IB_level_name: '子IB级别名称',
  Unable_to_apply_due_to_incomplete_information_or_failed_review: '资料不全或审核未通过,无法申请',
  The_commission_cannot_be_exceeded: '不能超过可提佣金',
  Commission_can_be_withdrawn: '可提取佣金',
  Recommended_traders: '推荐交易员',
  My_MAM_account: '我的MAM账户',
  Search_trader_nickname: '搜索交易员昵称',
  The_MAM_main_account_can_be_entrusted_to_manage_account_funds_and_independent_transactions_are_not_supported: 'MAM资管交易主账户，设置费率后开启交易',
  MAM_investment_accounts_can_be_entrusted_to_manage_their_account_funds_and_charge_corresponding_fees_to_support_independent_transactions: '投资人委托主账户管理账户资金，不支持自主交易',
  Open_an_account: '开户',
  MAM_main_account: 'MAM主账户',
  Use_CopyMaster_to_open_a_new_world_of_trading: '使用CopyMaster，开启交易新世界',
  commission_contribution: '佣金贡献',
  net_deposit: '净入金',
  Add_direct_customer: '新增直客',
  Please_select_a_time: '请选择时间',
  serial_number_num: '序号',
  Number_of_lots_to_close_position: '平仓手数',
  Number_of_trading_accounts: '交易账号数',
  Sub_IB_name_ID: '子IB姓名/ID',
  Direct_customer_name_ID: '直客姓名/ID',
  Statistics_Time: '统计时间',
  Approval_Status: '审核状态',
  total_commission: '总佣金',
  outside_commission: '外佣',
  inner_commission: '内佣',
  Attributed_Customer_IB: '归属客户/IB',
  Source_of_rebate: '返佣来源',
  Commission_record: '返佣记录',
  Belong_to_customers: '归属客户',
  MT_group: 'MT组',
  Customer_Name_ID_Trading_Account: '客户姓名/ID/交易账户',
  sub_IB: '子IB',
  Straight_off: '直客',
  Agent_level: '代理等级',
  Agent_name: '代理姓名',
  Agent_Name_ID: '代理姓名/ID',
  Direct_customer_list: '直客列表',
  Certification_status: '认证状态',
  Customer_Name: '客户姓名',
  Select_channel: '选择渠道',
  Sub_IB_link: '子IB链接',
  Commission_is_available: '可提佣金',
  Customet_Equity: '客户净值',
  System_Information: '系统消息',
  client_agreement: '客户协议',
  privacy_agreement: '隐私协议',
  risk_agreement: '风险协议',
  Use_RS_APP_to_manage_your_account_and_make_quick_transactions: '使用RS APP，管理您的账户快捷交易',
  Download_instructions_After_downloading_you_can_install_the_APK_through_your_mobile_phone: '下载说明：下载后可以通过手机安装APK',
  Download_instructions_iPhone_and_iPad_users_can_search_for_MetaTrader4_and_install_it_through_the_Apple_App_Store: '下载说明：iPhone和iPad用户可以通过Apple App Store搜索MetaTrader4安装。',
  iOS_mobile_version: 'IOS 移动端',
  System_requirements_Applicable_to_Windows_2008_7_8_10_operating_system: '系统要求：适用于Windows 2008/7/8/10操作系统',
  Windows_desktop_version: 'Windows 桌面版',
  Download_MetaTrader_4_and_experience_the_best_trading: '下载 MetaTrader 4，体验最佳交易！',
  Take_profit_price: '止盈价格',
  Pending_order_price: '挂单价格',
  Order_time: '挂单时间',
  Trading_profit_and_loss: '交易盈亏',
  Inventory_fee: '库存费',
  Stop_loss_price: '止损价格',
  Opening_price: '开仓价格',
  Lot: '手数',
  Trading_symbol: '交易品种',
  Opening_time: '开仓时间',
  Position: '持仓',
  Submitted_please_wait_for_review: '已提交，请等待审核',
  Payees_email: '收款人邮箱',
  Submitted_the_system_will_arrive_within_24_hours: '已提交,系统将在24小时内到账',
  The_amount_that_can_be_withdrawn_is_0: '可提取金额为0',
  Confirm_transfer_out: '确认转出',
  Transfer_another_persons_account: '转他人账户',
  Transfer_to_self_held_account: '转自持账户',
  Original: '原',
  At_least_greater_than_the_minimum_withdrawal_amount: '出金金额需大于最小金额{type}',
  withdrawal_amount_must_be_less_than_the_maximum_amount:'出金金额需小于最大金额{type}',
  At_least_greater_than_the_minimum_commission_amount: '出佣金额需大于最小金额{type}',
  commission_amount_must_be_less_than_the_maximum_amount:'出佣金额需小于最大金额{type}',
  Payment_amount: '打款金额',
  Amount_that_can_be_withdrawn: '可提取金额',
  Payee: '收款人',
  Complete_time: '完成时间',
  Balance_changes: '余额变动',
  Trading_Wallet_Account: '交易/钱包账户',
  serial_number: '流水号',
  review_time: '审核时间',
  Operation_method: '操作方式',
  Operation_type: '操作类型',

  processing_time: '处理时间',
  account: '账户',
  active_account: '活动账户',

  area: '地区',
  Detailed_address_local_language: '详细地址 (本地语言)',
  Upload_supporting_documents: '上传证明文件',
  Make_sure_the_document_shows_your_full_name_full_address_and_the_time_it_was_issued_or_is_vali: '确保文件显示您的完整姓名、完整地址和出具时间或有效期。',
  certified_documents: '证明文件',
  Please_upload_one_of_the_following_proof_of_address_documents: '请上传下列任一一份地址证明文件：',
  ID_card: '身份证',
  driver_license: '驾驶证',
  Property_bills_such_as_electricity_bills_water_bills_gas_bills_etc: '物业账单（如：电费、水费、燃气费等）',
  Internet_cable_telephone_bill: '网络/有线电视/电话的账单',
  Bank_statements: '银行对账单',
  credit_card_bill: '信用卡账单',
  residence_permit: '居住证',
  Affidavit_Certificate_of_Residence: '宣誓书/居住证',
  Household_register: '户口簿',
  Any_government_issued_documents: '任何政府开具的文件',
  please_enter_user_name: '请输入用户名',


  Gender: '性别',
  Upload_ID_photo: '上传证件照',
  Make_sure_the_ID_photo_document_shows_your_photo_full_name_date_of_birth_and_document_issue_date: '确保证件照文件显示您的照片、全名、出生日期和证件开具日期。',
  Demonstrate_correctly: '正确示范',
  Error_demonstration: '错误示范',
  ID_photo_reverse_side: '证件照反面',
  Support_jpg_or_png_format: '支持jpg或png格式',
  Photos_are_clear: '照片清晰',
  Details_clearly_visible: '细节清晰可见',
  Photo_quality: '照片高质',
  All_four_corners_of_the_document_are_visible: '文件的四个角均可视',
  Photo_is_blurry_and_out_of_focus: '照片模糊，未对焦',
  Details_not_shown_clearly: '未清晰显示细节',
  Photo_quality_is_low_too_dark_or_too_bright: '照片质量低（过暗或过亮）',
  All_four_corners_not_shown: '未显示所有四个角',
  ID_photo: '证件照',
  ID_photo_front: '证件照前面',
  Start_your_trading_journey: '开始您的交易旅程',
  undone: '未完成',
  Trading_System: '交易系统',
  server: '服务器',
  Download_trading_software: '下载交易软件',
  PC_version: 'PC版',
  Android_version: '安卓版',
  MT4_account: 'MT4账户',
  Leverage_ratio: '杠杆比例',
  _8_20_characters_including_uppercase_and_lowercase_letters_and_numbers: '8-20字符，包含大小写字母和数字',
  Please_select_account_type: '请选择账户类型',
  photo: '照片',
  Place_of_residence_region: '居住地 (地区)',
  proof_of_address: '地址证明',
  Local_remittance: '本地汇款',
  Beneficiary_bank_area: '收款银行地区',
  China: '中国',
  Beneficiary_bank_name: '收款银行名称',
  Recipient_bank_account_number: '收款银行账号',
  Bank_card_front: '银行卡正面',
  Bank_card_reverse_side: '银行卡反面',
  new_email: '新邮箱',
  The_current_time_period_is_unavailable: '当前时间段不可用',
  Currency: '币种',
  The_order_was_submitted_successfully_please_wait_for_system_review: '订单提交成功,请等候系统审核',
  Continue_to_deposit: '继续存款',
  check_order: '查看订单',
  Please_upload_payment_voucher: '请上传支付凭证',
  Please_enter_the_Hash_address_after_the_transaction: '请输入交易后的Hash地址',
  Billing_message: '收款信息',
  Coin_deposit_address: '存币地址',
  payment_voucher: '支付凭证',
  The_maps_address: '图片地址',
  Payer_wallet_address: '付款人钱包地址',
  wallet_address: '钱包地址',
  Blockchain_transaction_ID: '区块链交易ID',
  Hash_address_after_deposit_is_completed: '存款完成后的Hash地址',
  International_wire_transfer: '国际电汇',
  Bank_name: '银行名称',
  Bank_address: '银行地址',
  Payee_account: '收款人账户',
  Payee_Address: '收款人地址',
  Continue_to_withdraw_money: '继续取款',

  Please_review_and_activate_account: '请查看并激活账户',
  Activation_email_received: '未收到激活码',
  Insufficient_balance: '余额不足',
  Please_select_a_start_and_end_date: '请选择日期',
  Transfer_out_account: '转出账户',
  Withdrawal_account: '取款账户',
  depositUsdtTips: [
    '1.汇款完成后，请在数字货币钱包的提现记录里，将附带完整哈希地址的汇款凭证的截图，上传到汇款凭证处。'
  ],
  depositBankTips: [
    '1.请用与实际付款人姓名相同的银行卡进行转账。',
    '2.请不要习惯性转账，否则钱款可能无法追回。',
    '3.客户转账金额多于转账限额,款项打入了服务提供商的银行卡且难以追回，一切损失客户需要自行承担损失，公司不会提供任何补偿。',
    '4.进行银行转账时禁止提供任何备注，如果发现有任何备注，此金额将会退回，而且也会被收取金额的1-2%作为手续费。首次的错误操作将会邮件提醒，不会征收手续费。第二次将会由客户承担，一旦出现第三次的错误操作将会以恶意客户嫌疑封禁账号。',
    '5.如果客户使用异名入金转账，将会被收取金额的1-2%作为退款手续费后原路退款。公司政策是不允许异名入金，客户必须使用本人名义的银行卡进行入金，避免日后有不必要的资金流失。',
  ],
  Please_upload_a_photo_of_holding_your_ID_card: '请上传手持身份证照片',

  digital_currency: '数字货币',
  Confirm_payment_information: '确认支付信息',
  confirm_payment: '确认支付',
  upload_image: '上传图片',
  picture_address: '图片地址',
  main_wallet: '主钱包',
  deposit_account: '存款账户',
  Your_new_password_must_be_different_from_your_old_password: '您的新密码必须与旧的密码不同',
  Please_enter_the_phone_number: '请输入手机号码',
  Please_enter_the_email_address_in_the_correct_format: '请输入正确格式的邮箱',
  Already_have_an_account: '已有账户',
  live: '实盘',

  add_account: '添加账户',
  transaction_account: '交易账户',
  trade: '交易',
  reactivate: '重新激活',
  I_have_read_understood_and_agreed: '我已阅读、理解并同意',
  No_account_yet: '还没有账户',
  Account_details: '账户详情',
  pending_order: '挂单',

  // 新加的
  The_activation_email_has_been_sent_successfully_Please_go_to_the_email_to_confirm_the_activation_as_soon_as_possible_Thank_you:'激活邮件发送成功，请尽快前往邮箱确认激活，谢谢！',

  Good_evening: '晚上好',
  Good_afternoon: '下午好',
  good_morning: '上午好',
  family_name: '姓氏',
  Please_fill_in_the_true_and_valid_information: '请填写真实有效的信息',
  register: '注册',
  Return_to_login: '返回登录',
  Verification_Code: '验证码',
  Send_verification_code: '发送验证码',
  Verification_mode: '验证方式',
  safety_verification: '安全验证',
  Mobile: '手机号',
  Account: '账号',
  WelcomeToMaxain: '欢迎来到Maxain',
  // new
  dashboard: '仪表盘',
  // new
  limitRegistPassOneStep: '限制8-20个字符',

  transaction_status: '交易状态',
  home_agent: '归属代理',
  account_information: '账户信息',
  account_type: '账户类型',

  // 过渡版本加的
  total: '共计',
  item: '条',
  Whether_the_public: '是否公开',
  remark: '备注',
  field_name: '字段名',
  table_name: '表名',
  Input_search: '输入查找',
  userErrorTips: '请输入字母、数字和下划线的组合,长度在3到20个字符',
  optional: '选填',
  menuName: '名称',
  loginTimeoutTip: '登录过期,请重新登录',
  Yes: '是',
  no: '否',
  please_sign_in: '请登录',
  username: '用户名',
  password: '密码',
  Log_in: '登录',
  Role: '角色',
  please_choose: '请选择',
  please_input: '请输入',
  Resign: '离职',
  on_job: '在职',
  show: '展示',
  search: '搜索',
  add: '添加',
  name: '姓名',
  operate: '操作',
  Check: '查看',
  Edit: '编辑',
  delete: '删除',
  principal: '负责人',
  Confirm: '确认',
  cancel: '取消',
  select_operation: '选择操作',
  photo_album: '相册',
  camera: '相机',
  email: '邮箱',
  Superior: '上级',
  phone: '电话',
  save:'保存',
  personal_information:'个人资料',
  Menu_name:'菜单名称',
  description:'描述',
  state:'状态',
  Merchant:'商户',
  Enable:'启用',
  disabled:'禁用',
  Closure:'关闭',
  confirm_delete:'确定删除',
  confirm:'确定',
  Please_upload:'请上传',
  open:'开启',
  closed:'关闭',
  Component_name:'组件名称',
  Notice:'注意',
  Description_optional: '描述(选填)',
  // 旧个人中心start
  il8n:{
    change:'切换语言成功',
  },


  Please_select_a_time_range: '请选择查询时间范围',
  A_maximum_of_three_months_can_be_queried: '单次查询不能超过3个月',

  Web_trader: '网页交易端',
  balance: '余额',
  equity: '净值',
  Group: '分组',

  Redemption_expired: '兑换失效',
  Exchange_successfully: '兑换成功',
  Exchange_time: '兑换时间',
  Redeem_products: '兑换产品',
  quantity: '数量',
  Deduct_points: '抵扣积分',

  bonus_time: '奖励时间',
  Number_of_points: '积分数量',
  Transaction_deposit_amount: '交易/入金数量',
  behavior_type: '行为类型',
  single_deposit: '单次入金',
  first_deposit: '首次入金',
  behavioral_points: '行为积分',
  Trading_Points: '交易积分',
  Points_Available: '可用积分',
  redeemed: '已兑换',
  Points_record: '兑换记录',
  Summary_points: '总积分',
  Points_type: '积分类型',
  Points_Details: '积分明细',

  MAM_Account_Details: 'MAM账户详情',



  Commission_rebate_rules: '返佣规则',
  Add_a_link: '添加链接',
  Direct_customer_class_name: '级别名称',

  Modify_the_rebate_rules: '修改返佣规则',

  log_in_automatically_after: '后自动登录',

  important_Notice: '重要通知',
  do_not_show_again: '不再显示',
  Got_it: '知道了',


  mobile_phone: '手机',


  Please_upload_the_QR_code: '请上传二维码',
  Please_fill_in_the_address: '请填写地址',
  Please_enter_valid_usdt_address: '请输入正确的TRC20或BEP20钱包地址',

  bind365_tips: '请注意，务必填写TRC20或BEP20类型的地址，否则可能无法出金成功。',
  Please_activate_the_binding: '请激活在绑定',

  Holding_ID_photo: '手持证件照',
  Precautions: '注意事项',
  Handheld_ID_photo_verification_failed: '手持证件照审核失败',

  idRejectLabel: '个人信息审核失败',
  addressRejectLabel: '地址证明审核失败',
  bankRejectLabel: '银行卡信息审核失败',
  QR_code: '二维码',
  address: '地址',
  The_bank_card_information_has_been_submitted_successfully: '银行卡信息提交成功',
  Is_binding: '已绑定',
  The_commission_to_USDT: '出佣到USDT',
  The_commission_to_OTC365: '出佣到ChipPay',
  Bank_card_payment: '银行卡出金',
  withdrawOtcTipThirdlyLine: '系统将支付数字货币到第三方数字货币交易平台，由第三方平台自动匹配交易员，并完成数字货币的卖出，请确保交易前您已悉知交易风险。',
  withdrawOtcTipsSecondLine: '手续费1USDT，用于支付公链产生的矿工费。实时转账USDT到OTC365钱包，内置承兑，便捷出入金。',
  withdrawBankCardTipsThirdlyLine: '因配合监管机构反洗钱要求，Maxain将以客户入金方式相同币种支付。',
  withdrawBankCardTipsSecondLine: '2.不收取手续费，资金提取到本人银行卡。',
  withdrawUsdtTipsSecondLine: '2.手续费1USDT，用于支付公链产生的矿工费。',
  mamMasterOpenLimitTips: '上榜条件: 收益率大于0,净值大于$1000,指标每天更新一次',

  MAM_Investor: 'MAM投资账户',

  Payment_currency:'支付币种',
  Amount_deposited:'存款金额',
  share_threeMonthsReturn:'近三月最大回撤',
  share_rate_of_return:'收益率',
  The_poster_has_been_generated_please_share_it: '已生成海报，快去分享吧',
  Duplicated_link_go_share_it: '已复制链接，快去分享吧',
  Settlement_not_supported: '不支持结算',
  recommend: '推荐',
  Develop_your_customers_through_poster_links: '通过海报链接发展您的客户',
  Share_Master_Account: '分享主账户',
  Save_as_a_poster: '保存为海报',
  copylink: '复制链接',
  Sweep_code_to_follow_the_master_profit_together: '扫码跟随高手一起盈利',
  Close_to_5_liquidations: '近5笔平仓',
  Please_select_the_share_proportion: '请选择分成比例',
  Please_enter_an_integer_less_than_100: '请输入小于100的整数',
  Follow_Settings_Successfully: '跟随设置成功',
  Master_account_special: '主账户',
  Follow_the_set: '跟随设置',
  selected: '已选',
  noOpenTips: '该账户已设置为不公开,暂不支持订阅',
  management_rate_of_return: '管理收益率',
  clientBanlance: '客户余额',
  mamSettingChargeNewTips: ['1.开启收费后，如存在免费订阅者，未开启交易周期的订阅者将取消订阅，已开启交易周期的将取消自动续费；',
    '2.管理天数满15天且跟随账户空仓才能进行结算；',
    '3.可结算整个周期，也可结算单个跟随账户；',
    '4.管理费（管理资金*管理费比例）在加入交易周期时收取；',
    '5.表现费（盈利*分成比例）在结算时收取；',
    '6.未结算成功的账户进入下一个周期不收取管理费。'],

  ecnReadyOnlyTips: 'ECN账户最低入金要求是${money}，未满足要求暂时无法交易',
  mamSubReadyOnlyTips: 'MAM投资账户无法自主交易，仅能用于复制跟单',
  proReadyOnlyTips: 'PRO账户最低入金要求是${money}，未满足要求暂时无法交易',

  yesterday: '昨日',
  Nicknames_cannot_be_changed_after_they_are_set: '昵称设置后将无法修改',
  autonomous_transaction: '自主交易',
  Documentary_transactions: '跟单交易',
  integerTips: '请输入正整数',
  StopRatioValiteTips: '请输入0.01的倍数，不得超过100,最多两位小数',

  mamMasterSettingSaveTips: '1.如修改公开状态或订阅费，则所有跟随者将取消自动续费；<br/>2.如修改免费为收费，未开启交易周期的跟随者将取消订阅，已开启交易周期的将取消自动续费。',

  attention_please: '请注意',

  Charge_information_confirmation: '收费信息确认',
  You_have_read_and_agree: '您已阅读并同意',
  Documentary_agreement: '跟单协议',
  Please_enter_your_subscription_password: '请输入订阅密码',
  Not_less_than_the_minimum_funds_under_management: '不能少于最低管理资金',
  Please_select_a_MAM_account: '请选择mam账户',
  wrong_password: '密码错误',
  Subscribe_to_the_success: '订阅成功',
  Unavailable_account: '无可用账户',
  Now_open_an_account: '现在开户',


  Investment_account: '投资账户',
  copyValidateTips: '只能是0.01的倍数,并且最多两位小数',
  copyValueNullValidateTips: '请输入固定手数或固定比例',
  maximum_ratio: '最大比例',
  Now_deposit: '现在入金',
  available_balance: '可用余额',
  Please_enter_a_multiple_of_10: '请输入10的倍数',
  mamSubCopyMoneyTips: '启用时收取。表现费如下表，结算时收取。',
  The_account_to_pay_the_management_fee: '支付管理费的账号',
  Insufficient_available_balance: '可用余额不足,',
  Edit_success: '编辑成功',
  Account_number_has_reached_maximum_limit: '账户数已达到最大限制,',
  The_funds_under_management_must_not_exceed_the_account_balance: '管理资金不能大于账户余额',
  Please_enter_managed_funds: '请输入管理资金',

  Support_for_autonomous_trading: '支持自主交易',
  SocialMasterRoleTips: 'Social跟单信号源账户，支持自主交易',
  SocialSubRoleTips: '用于订阅跟单Social信号源账户，支持自主交易',
  mamMasterSubRoleTips: 'MAM资管交易主账户，设置费率并开启交易；',
  mamSubSubRoleTips: 'MAM投资账户，委托主账户管理账户资金,不支持自主交易',
  moneyRoleTips: '用于订阅收入和管理费支出，支持自主交易',

  no_limit: '不限制',
  fixed_lots: '固定手数',
  fixed_proportion: '固定比例',
  Smart_proportion: '智能比例',
  multiple: '倍',
  Experience_account: '体验',

  All_have_been_read: '全部已读',
  order: '订单',


  Subscribe_to_the_number_of: '订阅人数',
  filtrate: '筛选',
  maximum_drawdown: '最大回撤',
  week: '周',
  reset: '重置',

  stop: '停止',

  Renew: '续订',
  cost: '费用',

  invalid: '无效',
  valid: '有效',
  finished: '已结束',
  my_subscriptions: '我订阅的',
  Subscribe_to_my: '订阅我的',

  Investment_community: '投资社区',
  After_the_nickname_is_set_no_modification_is_allowed: '昵称设置后不允许修改',
  Wallet_account_edit_tips: '修改后，原钱包账户将变为普通账户',
  Confirm_save: '确认保存',
  idChangeTips: '账户身份设置后无法变更，确认保存？',

  please_enter: '请输入',
  Account_identity: '账户身份',
  Account_identity_tips1: '普通账户：用于自主交易；',
  Account_identity_tips2: '钱包账户：用于收支订阅费用，也支持自主交易；',
  Account_identity_tips3: 'Social主账户：Social跟单信号源账户；',
  Account_identity_tips4: 'Social投资账户：用于复制Social信号源账户进行投资，支持自主交易；',
  Account_identity_tips5: 'MAM主账户：可接受MAM投资账户委托管理其账户资金并收取相应费用，支持自主交易；',
  Account_identity_tips6: 'MAM投资账户：可委托MAM主账户管理账户资金，不支持自主交易。',

  My_balance: '我的余额',
  mamCancleTips: '取消订阅后，持仓订单将全部平仓且无法享受未到期的服务。管理费不退款，表现费请等待系统结算。确认取消？',
  Time_spent: '支出时间',
  Saved_successfully: '保存成功',
  Not_set: '未设置',

  Total_subscription_revenue: '订阅总收益',
  To_open_the_next_issue: '待开启下一期',
  Subscription_yield: '订阅收益率',

  Total_revenue: '总收入',
  Management_fee_ratio: '管理费比例',
  Performance_fee_ratio: '表现费比例',
  Follow_income: '跟随收益',
  Please_enter_the_management_fee_ratio: '请输入管理费比例',
  Please_enter_the_share_ratio: '请输入分成比例',
  Fill_in_at_least_one_charging_rule: '至少填写一项收费规则,管理费和表现费分成不能都为0',

  Settled_successfully: '结算成功',
  To_enable_the: '启用中',
  noEnableTheTips: '交易周期少于15天，不满足结算条件',
  Pending_settlement: '待结算',
  settled: '已结算',
  Customer_nickname: '客户昵称',

  Trading_cycle: '交易周期',
  Settlement_conditions: '结算条件',
  cycleTips1: '交易周期少于15天',
  cycleTips2: '跟随账户空仓',
  settle: '结算',
  Settlement: '结算中',
  Issue: '期号',
  Management_days: '管理天数',
  Personal_funds: '个人资金',
  Personal_gain: '个人收益',
  Manage_funds: '管理资金',
  Management_income: '管理收益',
  Estimate: '估算',

  startBeforeTipsTitle: '确认启用',
  startBeforeTips: '启用后开始新一轮交易周期，跟单设置将生效并扣除管理费，确认启用',
  Successfully_activated: '启用成功',
  settleBeforeTips: '结算期间将关闭跟单功能，启用后重新开启跟单，确认结算？',
  Confirm_settlement: '确认结算',

  Cumulative_number_of_managed_accounts: '累计管理账户数',
  Number_of_trading_periods: '管理期数',
  Accumulated_funds_under_management: '累计管理资金',
  Average_management_rate_of_return: '平均管理收益率',
  Total_Management_Revenue: '管理总收益',
  Average_billing_cycle: '平均结算周期',
  Total_personal_income: '个人总收益',
  Transaction_order: '交易订单',

  Stop_loss_ratio: '止损比例',
  Charging_cycle: '收费周期',
  Resubscribe: '重新订阅',

  signal_source: '信号源',
  Allocation: '分配方式',
  transactions: '笔',
  Maximum_follow_number: '最大跟随持仓笔数',
  Maximum_follow_lot: '最大跟随持仓手数',
  Follow_the_order: '跟随下单',
  Edit_subscription: '编辑订阅',
  unsubscribe: '取消订阅',
  socialSubCancelCopyButtonText: '确认取消',
  cancleSuccess: '取消成功',


  expenses: '支出',

  Autonomous_transaction: '自主交易',
  Copy_transaction: '复制交易',
  Autonomous: '自主',


  Is_it_public: '是否公开',
  Follower_funding_limit: '跟随者资金限制',
  Unlimited: '不限',
  Subscription_password: '订阅密码',
  digit6_combination_of_numbers_and_letters: '数字和字母组合的6-20位数',
  charge: '收费',

  nickname: '昵称',

  Copy_settings: '跟单设置',

  Payment_time: '支付时间',
  month: '月份',
  types_of_fee: '费用类型',
  payment_account: '付款账户',
  Pay_on_behalf_of: '代付',
  Collection: '代收',
  Accounts_receivable: '收款账户',

  Cumulative_number_of_follow: '累计跟随笔数',
  Cumulative_follow_lot: '累计跟随手数',


  Turned_on: '已开启',
  Not: '否',
  Automatic_renewal: '自动续费',
  Current_follow: '跟随笔数',
  Current_follow_lot: '跟随手数',
  Subscription_revenue: '订阅收益',
  Subscription_days: '订阅天数',

  Subscribing: '订阅中',
  expired: '已过期',

  Cumulative_subscription: '累计订阅',
  Cumulative_subscription_revenue: '累计订阅收益',
  Cumulative_subscription_lot: '累计订阅手数',
  income: '收入',


  Profitability: '盈利能力',
  Robustness: '稳健能力',
  Risk_control_ability: '风控能力',
  Fund_size: '资金规模',
  Trading_activity: '交易活跃度',

  Grand_total: '累计',
  Today: '当日',
  Nearly_three_months: '近三个月',
  Short: '做空',
  Do_more: '做多',
  Variety_ranking: '品种排行',
  Yield_curve: '收益曲线',

  Basic_Information: '基本信息',
  Subscription_fee: '订阅费',
  free: '免费',
  Experience: '体验',
  Share_ratio: '分成比例',
  Performance_fee: '表现费',

  management_fee: '管理费',
  No: '暂无',
  Strategy_description: '策略说明',
  Minimum_funding_limit: '最低资金限制',
  Master_account: '主',
  rate_of_return:'收益率',
  threeMonthsReturn:'近三月最大回撤',
  Overview:'概览',
  Setting:'设置',
  subscription:'订阅',
  Please_enter_a_nickname:'请输入昵称',
  Wallet_account: '钱包',
  Social_account: 'Social账户',
  MAM_account: 'MAM账户',
  MAM_master_account: '主账户',
  MAM_Investment_Account: '投资账户',
  Social_master_account: 'Social主',
  Social_Investment_Account: 'Social投资',
  You_can_also_add: '还可以新增',
  Trading_accounts: '个交易账户',
  More: '更多',
  Read_only: '只读',
  Identity: '身份',

  readOnlyTips: '由于净值低于信用额导致信用额冻结，可再次入金并联系客服申请解冻并继续完成任务，也可取消信用额直接解冻',
  stopRatioExplain: '当前净值/初始净值≤设定比例时，将暂停跟单，所有持仓订单强制平仓，止损比例重置。出入金或转账后该值也会被重置。',
  mtAccount: 'mt4账户',
  bind: '绑定',
  riskFileName: '风险披露',
  saveFileName: '安全说明',
  and: '和',
  limitRegistPassTwoStep: '包含大小写字母和数字',

  welcome: '欢迎来到',
  GoToRegister: '去注册',

  resetPass: '重置密码',
  To_log_in: '去登录',

  personal: '个人',
  partner: '合伙人',
  phoneEmtpyTips: '手机号不能为空',
  select_rebate_level: '请选择返佣级别',
  editSuceess: '修改成功',
  Modify_agent_level: '修改代理级别',
  Please_enter_password: '请输入密码',
  please_input_your_email: '请输入邮箱',
  registration_success: '注册完成待激活',
  activateImmediately:"立即激活",
  Please_keep_your_password_properly: '请妥善保存您的密码',
  pleaseEnterTheCompleteActivationCode:'请输入完整的激活码！',
  log_in_immediately: '立即登录',
  Upload_positive: '上传正面',
  Upload_negative: '上传反面',
  Privacy_agreement: '隐私协议',
  Prevent_money_laundering: '防止洗钱',
  safety_instructions: '安全说明',
  infoRejectTips: '请根据邮件提示，进行资料修改并重新提交',
  Authenticate_now: '立刻认证',
  My_rebate_rules: '我的返佣规则',
  The_highest_can_be_set: '最高可设',
  Please_fill_out: '请填写',
  Fill_in_at_most_one_decimal: '最多填写一位小数',
  Commission_statistics: '佣金统计',
  today: '今日',
  All: '全部',
  Nearly_a_month: '近一个月',
  Nearly_a_year: '近一年',
  Unbound: '未绑定',
  Home_agent: '归属代理',
  client: '客户',
  Myself: '本人',
  All_subordinates: '所有下级',
  Self_held_account_transfer_and_withdrawal: '自持账户转账出金',
  Transfer_and_withdraw_funds_from_other_accounts: '他人账户转账出金',
  Bank_card: '银行卡',
  Alipay: '支付宝',
  other: '其它',
  credit_amount: '信用额',
  Open_a_position: '开仓',
  Account_type: '账户种类',
  normal: '正常',
  Agent_ID: '代理ID',
  direct: '直接',
  indirect: '间接',
  Authentication_failed: '认证失败',
  Account_under_name: '名下账户',
  Registration_time: '注册时间',
  modify: '修改',
  Commission: '出佣',
  Choose_verification_method: '选择验证方式',
  correct: '正确',
  Investment_objective: '投资目标',
  of: '的',
  Transaction_history: '交易历史',
  Limit_more_than_6_characters: '限制大于6个字符',
  Contains_letters_and_numbers: '包含字母和数字',
  Direct_link: '直客链接',
  mine: '我的',
  Re: '重新',
  uploadAddressFileSuccessTips: '地址文件上传成功',
  Need_to_log_in_again: '需要重新登录',
  Ordinary_account: '普通',
  Demo_account: '模拟',
  openAccPageTips: '部分金融品种可能会受固定保证金要求影响，因此导致您的实际杠杆低于账户设置中选定的杠杆。具体信息请参考“合约细则”或访问我们的网站。',
  mockOpenSuccessTip: '模拟账户开立成功',
  Total_deposit: '总入金',
  Total_withdrawal: '总出金',
  Apply_to_transfer_out: '申请转出',
  profit: '盈利',
  Bank_card_number: '银行卡号',
  Transfer_out_to_bank_card: '转出到银行卡',
  Transfer_to_MT4: '转出到MT4',
  experienceNoCardTips: '请绑定银行卡再转出',
  experienceNoMt4Tips: '请先创建mt4账户',
  Account_has_expired: '账户已过期',
  personInfoAuthFail:'审核不通过',
  day: '天',
  mobileAreaTips:'请选择地区',
  details: '详情',
  accountDetails: '账号详情',
  orderSource: '订单来源',
  root:{
    selectPls:'请选择',
    enterPls:'请输入内容',
    confirm:'确定',
    cancle:'取消',
    noData:'暂无数据',
    dateTo:'至',
    startDate:'开始日期',
    endDate:'结束日期',
    search:'搜索',
    export:'导出',
    time:'时间',
    upper:'上一步',
    next:'下一步',
    yes:'有',
    no:'没有',
    selectAccount: '选择账户',
  },
  HeaderCom:{
    login:'登录',
    register:'注册',
    userCenter:'个人中心',
    invite:'邀请',
    exit:'退出',
  },
  Login:{
    login:'登录',
    passwordTip:'密码',
    forgetPwd:'忘记密码',
    register:'注册',
    phoneVer:'手机验证',
    emailVer:'邮箱验证',
    successSetPwd:'密码重置成功',
    loginTimeoutTip:'您的账号登录已经失效，请重新登录。',
  },
  Register:{
    title:'注册',
    perInfo:'个人资料',
    declare:'声明',
    firstName:'姓氏',
    lastName:'名字',
    rePswText:'确认密码',
    againVer:'后再次获取',
    errorPhon:'请填写正确的手机号',
    errorMail:'请填写正确的邮箱号码',
    errorFirstName:'请输入姓氏',
    notpassword:'密码输入错误',
    notrepassword:'输入的两次密码不一致，请重新输入',

    passwordDes:"必须包含大小写字母和数字的组合，不能使用特殊字符，长度在8-20之间",
    verText:"验证码",
    submitText:'提交',
    successTips1:'激活码已发至您的注册邮箱：',
    successTips2:',请查收并激活账号',
    successTips4:'重新发送',
    successTips5:'激活邮件发送成功，请尽快前往邮箱确认激活，谢谢！',
    sendEmail:'发送激活邮件',
    unCheck:'未激活',
    userName:'用户名称',
    idNo:'证件号码',
    openAcc:'确认开户',
  },
  About:{
    branch:'办事处',
    phone:'电话',
    language:'语言',
    sendEmail:'发送电子邮件',
    name:'姓名',
    email:'邮箱',
    submitText:'提交申请',
    notice:'公告',
  },
  Home:{
    least:'最低入金',
    lever:'杠杆',
    accountType:'账户类型',
    forexVolume:'交易量',
    forexLot:'手',
  },
  Partner:{
    name:'名字',
    email:'邮箱',
    region:'请指明您计划开展经营的地区',
    experience:'您有没有与其他金融公司合作过？如有，请说明是哪些公司，于何时合作？',
    upload:'上传',
    inputVer:'请输入验证码',
    commitSuccess:'提交成功',
    delete:'确定移除',
  },
  Tools:{
    exchange:'货币转换',
    year:'年',
    month:'月',
    day:'日',
    USD:'美国美元',

  },
  Trade:{
    equity:'净值（USD)',
    payType:'支付系统',
    deposit:'存入资金',
    withdraw:'提取资金',
    oper:'操作',
    mix:'最低',
    max:'最高',
    poundage:'手续费',
    depo:'入金',

    /*新的银联支付方式*/
    title: '支付金额并确认',
    subtitle: '完成充值后您购买的数字货币将全额充值到该商户',
    orderNo: '订单号',
    payMoney: '支付金额',
    copy: '复制',

    bankInfo: '银行信息：',
    remark: '付款备注：',
    countDown: '支付倒计时：',
    warning: '警告：如未成功转账，请勿点击“确认已支付”，否注将会限制当日买入及到账！',
  },
  Train:{
    all:'全部',
    class:'分类',
    sort:'排序',
    lecturesAddr:'详细地址',
    viewMore:'查看更多',
    apply:'立即报名',
    firstName:'姓',
    lastName:'名',
    experience:'经验',
    phone:'手机号码',
    email:'邮箱',
    yes:'有',
    no:'没有',
    back:'返回',
  },
  Market:{
    calendar:'经济日历',
    time:'时间',
    event:'事件',
    important:'重要性',
    now:'今值',
    pre:'前值',
  },
  User:{
    home:'主页',
    myAcc:'我的账户',
    monChan:'入金',
    partner:'合作伙伴',
    perInfo:'个人资料',
    goldManage:'赠金记录',
    setup:'账户设置',
    leastDeposit:'最低入金',
    leverage:'杠杆',
    forexLeverage:'外汇杠杆',
    preciousMetalLeverage:"贵金属杠杆",
    liquidationRatio:"强平比例",
    collateralMarginRatio:"锁仓保证金比例",
    accountCardTips1:"外汇货币对的杠杆",
    accountCardTips2:"黄金和白银的杠杆",
    accountCardTips3:"保证金水平降至或低于此阈值时，系统将自动平仓。",
    accountCardTips4:"订单对锁时每个订单的保证金占用的百分比",
    withdrawtipsName:"账户持仓情况下可提取金额为可用保证金*",
    withdrawtipsAction:"，如需特殊提取请联系在线客服协助。",
    leverageBest:'杠杆最高',
    unit:'最小合约单位（合约量）',
    miniSpreads:'最低点差',
    selectLev:'请选择杠杆',
    currency:'账户货币',
    openAcc:'开立账户',
    accountList:'账户列表',
    totalBalance:'总余额',
    applyCommi:'申请出佣',
    status:'状态',
    remainAmount:'可出佣金额',
    transactionStatus: '交易状态',
    startUsing: '启用',
    forbidden: '禁用',
    login:'账号',
    accType:'类型',
    balance:'当前余额',
    equity:'当前资产净值',
    credit: '信用额',
    marginFree:'可用保证金',
    profitRate:'账户总利润率（%）',
    openOrder:'未结订单数',
    closeOrder:'已结订单数',
    createTime:'注册日期',
    checking:'资料审核中',
    userInfo:'个人信息',
    name:'姓名',
    surnameNullMessage: '请输入姓',
    nameNullMessage: '请输入名字',
    regionNullMessage: '请选择地区',
    gender:'性别',
    man:'先生',
    women:'女士',
    nationality:'国籍',
    homeCountryCode:'居住国',
    phone:'手机号码',
    certId:'证件号码',
    birthday:'出生日期',
    authentication:'身份验证',
    authPass:'审核通过',
    authing:'审核中',
    addressVerifi:'地址验证',
    sumit:'提交审核',
    authSubmitSuccess:'身份证明提交成功',
    add:'添加',
    email:'邮箱',
    newPhone:'新手机号',
    sendVeri:'发送验证码',
    sendDesc:'后再次获取',
    phoneVerCode:'手机验证码',
    emailVerCode:'邮箱验证码',
    save:'保存',
    verCodeSendSuccess:'验证码发送成功',
    plsInputNewPhone:'请输入您的新手机号',
    plsInputPhoVer:'请输入验证码',
    addPhoneSuccess:'添加成功',
    worlSta:'就业状况',
    industry:'行业',
    income:'年收入',
    netAsset:'净资产',
    curAsset:'流动资产',
    fundsSource:'投资资金来源',
    bankCardInfo:'银行卡信息',
    bankAccount:'银行帐号',
    bankName:'开户银行',
    receivingCurrency:"收款币种",
    account_currency:"账户币种",
    bankOutlet:'开户支行',
    reBind:'重新绑定',

    worlStaNullMessage: '请选择就业状况',
    industryNullMessage: '请选择行业',
    incomeNullMessage: '请选择年收入',
    AssetsNullMessage: '请选择净资产',
    runAssetsNullMessage: '请选择你的流动资产',
    fundsSourceNullMessage: '请勾选你的投资资金来源',

    plsInputBankFront:'请上传银行卡照片（正面）',
    plsInputBankBack:'请上传银行卡照片（反面）',
    plsInputBankAccount:'请输入银行帐号',
    plsInputBankName:'请输入开户银行',
    plsInputBankOutlet:'请输入开户支行',
    CNYNAME:"人民币",
    VNDNAME:"越南盾",
    Rpcurrency:"印尼盾",
    OTHER_BANKS:"其他银行",
    plsInputSwiftCode:'请输入SwiftCode',
    investExp:'投资经验',
    invTarget:'投资目标是',
    levHis:'请告诉我们您是否有其它杠杆式产品（如窝轮、期货、期权）交易历史',
    howTrade:'您是如何交易以上产品的？',
    invTargetIs:'您的投资目标是？（可多选）',
    plsInputInvTarget:'您的投资目标是？',
    firstName:'姓',
    cardType:'证件类型',
    plsInputAddress:'请选择地区',
    plsInputName:'请输入姓名',
    openAccTips3:'我认为贵公司提供的产品适合我',
    openAccTips4:'我理解此投资产品为投机性，并且我可以根据个人财务状况承担所有投资金额风险',
    openAccTips5:'我理解在交易杠杆产品时，我冒着失去所有投资资金的风险；我有责任通过风险管理工具(例如止损单)来监控我的仓位并管理交易风险。',
    openAccTips6:'本人同意客户协议书及所有条款采用电子形式而非纸质形式收集和发送，包括文件电子签名和账户信息的发送。',
    openAccTips7:'此外，本人声明，本人提供的所有开户信息均真实准确并保证在内容有任何变化的情况下以书面形式通知经纪商公司，必要时，本人授权经纪商公司对资料的准确性进行校验确认。',

    //转账
    transferAccounts:'转账',
    from:'从',
    to:'到',
    amount:'金额',
    onlyInputTwoBitNumber:'只能输入两位小数金额',
    transDesc:'如果您知道收款人的电子邮件地址（收款人个人专区的主要电子邮件或任何替代性电子邮件地址），请输入。系统将验证您输入的收款人账号和电子邮件地址是否正确。如果它们不匹配，则内部转账不会执行。',
    transAmount:'转账金额',
    fee:'手续费',
    //tradeHistory
    payType:'支付方式',
    num:'编号',
    searchType1:'银联入金1',
    searchType2:'自持账户转入',
    searchType3:'他人账户转入',
    searchType4:'银联入金2',
    searchStatus2:'入金成功',
    searchStatus3:'入金失败',
    outAmount:'出金金额',
    searchOutType1:'出金到银行卡',
    searchOutType2:'出金到自有账户',
    searchOutType3:'出金到他人账户',
    searchOutType4:'其他',
    searchOutStatus1:'审核中',
    searchOutStatus2:'出金成功',
    searchOutStatus3:'出金失败',
    depositTimeTips:'该渠道不在可用时间段内，请选在其他渠道，谢谢！',
    //moneyChange
    in:'入金',
    out:'出金',
    limit:'限额',
    timeLimit:'限时',
    moneyConfirm:'确认',
    moneyBanlanceNotEnough:'可用余额不足，请选择其他账号提款',
    moneyAmountError:'出金金额大于可提款金额',
    moneyAmountErrorCommission:'出佣金额大于可提款金额',
    //setting
    leverSet:'杠杆设置',
    modifyLeverSuccess:'杠杆修改成功',
    saveSetting:'保存设置',
    passSet:'密码设置',
    newPass:'新密码',
    confirmPass:'再次输入密码',
    plsInputPass:'请输入新密码',
    plsInputConfirmPass:'请输入确认密码',
    modifyPass:'更改密码',
    passType2:'交易密码',
    passType3:'投资密码',
    passSetSuccess:'修改密码成功',
    //partner
    commissionBanlance:'余额',
    totalProfit:'总收益',
    copySuccess:'复制成功',
    reportCloseOrder:'平仓单',
    reportSubibList:'子IB列表',
    reportCommiRecord:'出佣记录',
    reportOrderId:'订单号',
    reportCusId:'客户ID',
    reportSymbol:'品种',
    reportCmd:'交易类型',
    reportVolume:'交易量',
    reportCurrentPrice:'当前价格',
    reportCloseTime:'平仓时间',
    reportClosePrice:'平仓价格',
    reportSl:'止损',
    reportTp:'止盈',
    reportStorage:'利息',
    reportProfit:'盈亏',
    total:'合计',
    buy:'买入',
    sell:'卖出',
    reportCusType:'客户类型',
    reportBanlance:'余额',
    reportEquity:'净值',
    reportImgStatus:'资料认证',
    reportCreateTime:'开户时间',
    reportDir:'直接客户',
    reportIndir:'间接客户',
    auth: '认证',
    identifyStatus0:'未认证',
    identifyStatus1:'认证不通过',
    identifyStatus2:'认证中',
    identifyStatus3:'认证通过',
    custStatus2:'开户成功',
    custStatus3:'审核中',
    custStatus4:'审核失败',
    reportComiType:'出佣方式',
    reportComiType1:'出佣到银行卡',
    reportComiType2:'内部转账',
    reportCommiAmount:'出佣金额',
    reportCommiStatus1:'出佣成功',
    reportCommiStatus2:'已否绝/取消',
    reportCommiStatus3:'审核中',
    confirmCancelCommission:'确认取消出佣',
    confirmCancelWithdrawal :'确认取消出金',
    applyTime:'申请时间'
  },
  contractDetailed: {
    tradingHour: '交易时间',
  },
  riskExplain: {
    title: '风险与声明'
  },
  // 佣金规则相关
  'cannot_be_empty': '不能为空',
  'invite_code': '邀请码',
  assetsList: {
    level1: '少于$25,000',
    level2: '$25,000 - $49,999',
    level3: '$50,000 - $99,999',
    level4: '$100,000 - $249,999',
    level5: '$250,000 - $1,000,000',
    level6: '多于$1,000,000',
  },
  certTypes: {
    idCard: '身份证',
    passport: '护照',
    driverLicense: '驾驶证',
    householdBook: '户口本',
    residencePermit: '居住证',
  },
  countryList: {
    china: '中国',
    taiwan: '中国台湾',
    hongKong: '中国香港',
    macau: '中国澳门',
    mongolia: '蒙古',
    japan: '日本',
    philippines: '菲律宾',
    vietnam: '越南',
    laos: '老挝',
    cambodia: '柬埔寨',
    burma: '缅甸',
    thailand: '泰国',
    malaysia: '马来西亚',
    brunei: '文莱',
    singapore: '新加坡',
    indonesia: '印度尼西亚',
    eastTimor: '东帝汶',
    nepal: '尼泊尔',
    bhutan: '不丹',
    bangladesh: '孟加拉国',
    india: '印度',
    pakistan: '巴基斯坦',
    sriLanka: '斯里兰卡',
    maldives: '马尔代夫',
    kazakhstan: '哈萨克斯坦',
    kyrgyzstan: '吉尔吉斯斯坦',
    tajikistan: '塔吉克斯坦',
    uzbekistan: '乌兹别克斯坦',
    turkmenistan: '土库曼斯坦',
    afghanistan: '阿富汗',
    iraq: '伊拉克',
    syria: '叙利亚',
    jordan: '约旦',
    israel: '以色列',
    palestine: '巴勒斯坦',
    saudiArabia: '沙特阿拉伯',
    bahrain: '巴林',
    qatar: '卡塔尔',
    kuwait: '科威特',
    unitedArabEmirates: '阿拉伯联合酋长国（阿联酋）',
    oman: '阿曼',
    yemen: '也门',
    georgia: '格鲁吉亚',
    armenia: '亚美尼亚',
    azerbaijan: '阿塞拜疆',
    turkey: '土耳其',
    cyprus: '塞浦路斯',
    finland: '芬兰',
    sweden: '瑞典',
    norway: '挪威',
    iceland: '冰岛',
    denmark: '丹麦',
    faroeIslands: '法罗群岛（丹）',
    estonia: '爱沙尼亚',
    latvia: '拉脱维亚',
    lithuania: '立陶宛',
    russia: '俄罗斯',
    moldova: '摩尔多瓦',
    poland: '波兰',
    czechRepublic: '捷克',
    slovakia: '斯洛伐克',
    hungary: '匈牙利',
    germany: '德国',
    austria: '奥地利',
    switzerland: '瑞士',
    liechtenstein: '列支敦士登',
    unitedKingdom: '英国',
    ireland: '爱尔兰',
    netherlands: '荷兰',
    belgium: '比利时',
    luxembourg: '卢森堡',
    france: '法国',
    monaco: '摩纳哥',
    romania: '罗马尼亚',
    bulgaria: '保加利亚',
    serbia: '塞尔维亚',
    macedonia: '马其顿',
    albania: '阿尔巴尼亚',
    greece: '希腊',
    slovenia: '斯洛文尼亚',
    croatia: '克罗地亚',
    bosnia: '波斯尼亚',
    meskovina: '墨塞哥维那',
    chad: '乍得',
    centralAfrica: '中非',
    cameroon: '喀麦隆',
    equatorialGuinea: '赤道几内亚',
    gabon: '加蓬',
    saoTome: '圣多美及普林西比',
    mauritania: '毛里塔尼亚',
    westernSahara: '西撒哈拉',
    senegal: '塞内加尔',
    gambia: '冈比亚',
    mali: '马里',
    burkinaFaso: '布基纳法索',
    guinea: '几内亚',
    guineaBissau: '几内亚比绍',
    capeVerde: '佛得角',
    sierraLeone: '塞拉利昂',
    ghana: '加纳',
    togo: '多哥',
    benin: '贝宁',
    niger: '尼日尔',
    canaryIslands: '加那利群岛（西）',
    zambia: '赞比亚',
    angola: '安哥拉',
    zimbabwe: '津巴布韦',
    malawi: '马拉维',
    mozambique: '莫桑比克',
    botswana: '博茨瓦纳',
    namibia: '纳米比亚',
    southAfrica: '南非',
    swaziland: '斯威士兰',
    lesotho: '莱索托',
    madagascar: '马达加斯加',
    comoros: '科摩罗',
    mauritius: '毛里求斯',
    reunion: '留尼旺（法）',
    stHelena: '圣赫勒拿（英）',
    australia: '澳大利亚',
    newZealand: '新西兰',
    papuaNewGuinea: '巴布亚新几内亚',
    solomonIslands: '所罗门群岛',
    vanuatu: '瓦努阿图',
    micronesia: '密克罗尼西亚',
    marshallIslands: '马绍尔群岛',
    palau: '帕劳',
    nauru: '瑙鲁',
    kiribati: '基里巴斯',
    tuvalu: '图瓦卢',
    samoa: '萨摩亚',
    fijiIslands: '斐济群岛',
    tonga: '汤加',
    cookIslands: '库克群岛',
    guam: '关岛',
    newCaledonia: '新喀里多尼亚(法)',
    polynesia: '波利尼西亚',
    pitcairnIsland: '皮特凯恩岛（英）',
    wallisAndFutuna: '瓦利斯与富图纳（法）',
    niue: '纽埃',
    tokelau: '托克劳',
    mexico: '墨西哥',
    greenland: '格陵兰（丹）',
    guatemala: '危地马拉',
    belize: '伯利兹',
    elSalvador: '萨尔瓦多',
    honduras: '洪都拉斯',
    nicarguagua: '尼加拉瓜',
    costaRica: '哥斯达黎加',
    panama: '巴拿马',
    bahamas: '巴哈马',
    cuba: '古巴',
    jamaica: '牙买加',
    haiti: '海地',
    dominicanRepublic: '多米尼加共和国',
    antigua: '安提瓜',
    barbuda: '巴布达',
    stKitts: '圣基茨',
    nevis: '尼维斯',
    dominic: '多米尼克',
    saintLucia: '圣卢西亚',
    saintVincent: '圣文森特',
    grenadines: '格林纳丁斯',
    grenada: '格林纳达',
    barbados: '巴巴多斯',
    trinidad: '特立尼达',
    tobago: '多巴哥',
    puertoRico: '波多黎各',
    anguilla: '安圭拉',
    montserrat: '蒙特塞拉特',
    guadeloupe: '瓜德罗普',
    martinique: '马提尼克',
    netherlandsAntilles: '安的列斯',
    aruba: '阿鲁巴',
    turksAndCaicos: '特克斯和凯科斯群岛',
    caymanIslands: '开曼群岛',
    bermuda: '百慕大',
    colombia: '哥伦比亚',
    venezuela: '委内瑞拉',
    guyana: '圭亚那',
    suriname: '苏里南',
    ecuador: '厄瓜多尔',
    peru: '秘鲁',
    bolivia: '玻利维亚',
    brazil: '巴西',
    chile: '智利',
    argentina: '阿根廷',
    uruguay: '乌拉圭',
    paraguay: '巴拉圭',
    italy: '意大利',
    vatican: '梵蒂冈',
    sanMarino: '圣马力诺',
    malta: '马耳他',
    spain: '西班牙',
    portugal: '葡萄牙',
    andorra: '安道尔',
    egypt: '埃及',
    tunisia: '突尼斯',
    algeria: '阿尔及利亚',
    morocco: '摩洛哥',
    azores: '亚速尔群岛（葡）',
    madeiraIslands: '马德拉群岛（葡）',
    ethiopia: '埃塞俄比亚',
    djibouti: '吉布提',
    kenya: '肯尼亚',
    tanzania: '坦桑尼亚',
    uganda: '乌干达',
    rwanda: '卢旺达',
    burundi: '布隆迪',
    seychelles: '塞舌尔',
    nigeria: '尼日利亚',
    ukraine: '乌克兰',
    pakistanNew: '巴基斯坦',
    iran: '伊朗',
    unitedStates: '美国',
    canada: '加拿大',
    southKorea: '韩国',
    northKorea: '朝鲜',
  },
  fundsSourceList: {
    jobIncome: '工作收入',
    heritage: '遗产',
    savingsInvestment: '储蓄及投资',
    other: '其他',
  },
  incomeList: {
    level1: '少于$25,000',
    level2: '$25,000 - $49,999',
    level3: '$50,000 - $99,999',
    level4: '$100,000 - $249,999',
    level5: '$250,000 - $1,000,000',
    level6: '多于$1,000,000',
  },
  industryList: {
    insurance: '保险',
    law: '法律',
    engineering: '工程建筑',
    internet: '互联网',
    advertising: '广告公关',
    aviation: '航空',
    finance: '金融会计',
    construction: '建造培训',
    banking: '金融服务',
    tourism: '旅游',
    logistics: '物流运输',
    healthcare: '医护服务',
    media: '艺术娱乐媒体',
    government: '政府军事',
    manufacturing: '制造生产',
    it: '资讯科技',
  },
  invTargetList: {
    shortTerm: '中短期投资',
    hedging: '对冲',
    longTerm: '长线交易',
    diversified: '多元化投资',
  },
  sexList: {
    male: '男',
    female: '女',
  },
  workList: {
    employed: '全职',
    partTime: '兼职',
    selfEmployed: '自雇',
    retired: '已退休',
    student: '学生',
    unemployed: '失业',
  },
  'more_links': '更多链接',
  'direct_link': '直客链接',
  'copy_link': '复制链接',
  'copy_content_to_clipboard': '复制内容到剪贴板',
  'edit_link_settings': '修改返佣规则',
  'view_qr_code': '查看二维码',
  'view_rebate_rules': '查看返佣规则',
  'cannot_be_negative': '不能为负数',
  'max_two_decimal_places': '最多允许两位小数',
  'max_four_decimal_places': '最多允许四位小数',
  'only_integers_allowed': '只能输入整数',
  'max_one_decimal_place': '最多允许一位小数',
  //电汇
  telegraphicTransfer:{
    tips: '安全交易须知',

  },
  // 赠金
  withgold:{
    title: '赠金记录',
    Numbering: '编号',
    accountNumber: 'MT4账号',
    BonusType: '赠金类型',
    BonusAmount: '赠金',
    DepositAmount: '入金',
    EventName: '活动名称',
    NumberOfLots: '达标手数',
    LotsCompleted: '已完成手数',
    ExpireDate: '到期时间',
    status: '状态',
    freeStatusTipsOne: '由于净值低于信用额导致信用额冻结,',
    freeStatusTipsTwo: '可再次入金并联系客户经理申请解冻并继续完成任务,',
    freeStatusTipsThree: '也可取消信用额直接解冻',
    operating: '操作',
    RollOut: '转出',
    statusEnd: '已结束',
    statusDuring: '进行中',
    statusExpired: '已过期',
    statusFree: '已冻结',
    statusComple: '已完成',
    statusCancle: '已取消',
    statusReview: '转正审核',
    sureTitle1: '当前可转出',
    sureTitle2: '转出信用额有触发平仓风险,建议未持仓时申请',
    sureTitleCenter: '转到余额',
    operatingSuccess: '操作成功',
    cancleTitle: '取消信用额有触发平仓的风险，建议您在未持仓时取消',

    // 转出记录页面
    mt4Account: 'MT4账号',
    RollOutAmount: '转出金额($)',
    SubmitTime: '提交时间',
    withgoldOut1: '待审核',
    withgoldOut2: '已通过',
    withgoldOut3: '已拒绝',

    // 头部
    selectAccount: '请选择账户',
    inputEventName: '输入活动名称',
    clearEmipt: '清空',

    // tab
    TransferRecord: '转出记录',
    // 账号冻结状态的提示
  },
  payChannel:{
    inputMoney: '请输入入金金额',

  },
  // 积分商城菜单下的,没有英语版本的
  integralShop:{
    sort_by: '排序方式'
  },
  download:{
    subtitle:"下载 MetaTrader 4，体验最佳交易！",
    smallTextwindows:"Windows 桌面版",
    smallTextios:"iOS 移动端",
    windowsdesc:"系统要求：适用于Windows 2008/7/8/10操作系统",
    iosdesc:"下载说明：iPhone和iPad用户可以通过Apple App Store搜索MetaTrader4安装。",
    androiddesc:"下载说明：下载后可以通过手机安装APK"
  },
  address_prompt:"您填写的地址信息必须与您提供的地址证明文件上的信息保持一致，否则可能导致认证失败。"
}
